import { Fragment, FC } from 'react'
import { Box, IconButton, Hidden } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import times from 'lodash/times'
import Skeleton from '@app.components/Skeleton'
import BookMark from 'svgIcons/BookMark'

const useStyles = makeStyles((theme) => {
  return {
    root: {
      backgroundColor: 'white',
      padding: '20px 0',
      width: '100%',
      borderBottom: '1px solid #fafafa',
    },
    flexWrapper: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    scrapButton: {
      color: '#e8e8e8',
    },
    bookmarkIcon: {
      width: 15,
    },
    basicInfo: {
      width: 100,
      marginRight: 25,
      flexShrink: 0,
      alignItems: 'center',
      display: 'flex',
    },
    specInfo: {
      marginRight: 3.75,
      marginBottom: 0.5,
      width: '100%',
      flexGrow: 0,
      flexShrink: 0,
    },
    content: {
      marginRight: 3.75,
      marginBottom: 0.5,
      marginTop: 5,
      width: '100%',
      flexGrow: 1,
    },
    contentWrapper: {
      mr: 3.75,
      flexGrow: 1,
      display: 'flex',
      minWidth: 0,
      maxWidth: '100%',
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
    mobileSkeleton: {
      marginBottom: 5,
    },
    scrapIcon: {
      flexShrink: 0,
      marginLeft: 55,
      [theme.breakpoints.down('sm')]: {
        marginLeft: 10,
      },
    },
  }
})

interface LoadingItemProps {
  className?: string
  variant?: 'auto' | 'pc' | 'mobile'
}

const LoadingItem: FC<LoadingItemProps> = ({ className, variant = 'auto' }) => {
  const classes = useStyles()
  const columnTimes = times(4)
  return (
    <>
      <Box className={clsx(classes.root, classes.flexWrapper, className)}>
        {/* PC */}
        <Hidden
          smDown={variant === 'auto' || variant === 'mobile'}
          mdUp={variant === 'mobile'}
          implementation="css"
        >
          <Box className={classes.flexWrapper}>
            {columnTimes.map((column) => {
              return (
                <Box key={column} className={classes.basicInfo}>
                  <Skeleton width={100} />
                </Box>
              )
            })}

            <Box flexGrow={1} display="flex" minWidth={0} alignItems="center">
              <Box className={classes.contentWrapper}>
                <Box className={classes.specInfo}>
                  <Skeleton height={16} width={350} />
                </Box>
                <Box className={classes.content}>
                  <Skeleton height={70} width={500} />
                </Box>
              </Box>
            </Box>
          </Box>
        </Hidden>

        {/* MOBILE */}
        <Hidden
          mdUp={variant === 'auto' || variant === 'pc'}
          implementation="css"
        >
          <Box className={classes.flexWrapper}>
            <Box display="block">
              <Skeleton
                width={200}
                height={20}
                className={classes.mobileSkeleton}
              />
              <Skeleton
                width={250}
                height={20}
                className={classes.mobileSkeleton}
              />
              <Skeleton
                width={280}
                height={35}
                className={classes.mobileSkeleton}
              />
            </Box>
          </Box>
        </Hidden>

        <Box className={classes.scrapIcon}>
          <IconButton className={classes.scrapButton} disabled>
            <BookMark className={classes.bookmarkIcon} />
          </IconButton>
        </Box>
      </Box>
    </>
  )
}

interface LoadingListItemProps {
  length: number
  className?: string
  variant?: 'auto' | 'pc' | 'mobile'
}

const LoadingListItem: FC<LoadingListItemProps> = ({ length, ...props }) => {
  const lodingItems = times(length)

  return (
    <Box>
      {lodingItems.map((item) => (
        <Fragment key={item}>
          <LoadingItem {...props} />
        </Fragment>
      ))}
    </Box>
  )
}

export default LoadingListItem
